import { autoinject } from 'aurelia-framework';
import { WidgetService } from '../services/widget-service';
import { ReportPageData, ReportPageLayout } from '../clients/reporting-clients';
import { IWidget } from '../widgets/i-widget';

@autoinject
export class ReportPageDataToWidgetsValueConverter {
  constructor(private widgetService: WidgetService) { }

  toView(data: ReportPageData | ReportPageLayout | undefined, useDraft?: boolean): IWidget[] {
    const widgetDatas = data instanceof ReportPageData && useDraft ? (data?.draftWidgets ?? data?.widgets) : data?.widgets;
    return widgetDatas?.map<IWidget>(x => {
      const widget = this.widgetService.availableWidgets.find(y => y.name === x.name);
      return widget
        ? {
          name: widget.name,
          viewModel: widget.viewModel,
          x: x.x, y: x.y, w: x.w, h: x.h,
          config: x.config
        }
        : undefined;
    }).filter(x => !!x) ?? [];
  }

  // getEffectiveConfig(original: IWidgetConfig, data: ReportPageData | ReportPageLayout | undefined): IWidgetConfig {
  //   if (!(data instanceof ReportPageData)) {
  //     return original;
  //   }
  //   const config: IWidgetConfig = { ...original };
  //   Object.keys(config).filter(x => typeof (config[x]) === 'string' && config[x]?.startsWith('@')).forEach(x => {
  //     const p = data.parameters?.find(p => `@${p.name}` === config[x]);
  //     if (p) {
  //       config[x] = p.value;
  //     }
  //   });
  //   return config;
  // }

}
